import React, { createContext, useState, useEffect } from 'react';
import authService from '../services/authService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [require2FA, setRequire2FA] = useState(false);
  const [tempEmail, setTempEmail] = useState('');

  useEffect(() => {
    // Check if user is already logged in
    const currentUser = authService.getCurrentUser();
    if (currentUser) {
      setUser(currentUser);
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const signup = async (email, password, firstName, lastName, phone) => {
    const result = await authService.signup(email, password, firstName, lastName, phone);
    if (result.success) {
      setUser(result.data.user);
      setIsAuthenticated(true);
      return { success: true };
    }
    return { success: false, error: result.error };
  };

  const login = async (email, password) => {
    const result = await authService.login(email, password);
    if (result.success) {
      // Check if 2FA is required
      if (result.data.require2FA) {
        setRequire2FA(true);
        setTempEmail(email);
        return { success: true, require2FA: true };
      }
      setUser(result.data.user);
      setIsAuthenticated(true);
      return { success: true };
    }
    return { success: false, error: result.error };
  };

  const setup2FA = async () => {
    const result = await authService.setup2FA();
    return result;
  };

  const verify2FA = async (code) => {
    const result = await authService.verify2FA(code);
    if (result.success) {
      setUser(result.data.user);
      setIsAuthenticated(true);
      setRequire2FA(false);
      setTempEmail('');
      return { success: true };
    }
    return { success: false, error: result.error };
  };

  const logout = () => {
    authService.logout();
    setUser(null);
    setIsAuthenticated(false);
    setRequire2FA(false);
  };

  const value = {
    user,
    isAuthenticated,
    loading,
    require2FA,
    tempEmail,
    signup,
    login,
    logout,
    setup2FA,
    verify2FA,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
